import Home from './components/Home';
import { AppProvider } from './context/AppContext';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Players from './components/Players';
import { ChakraProvider} from '@chakra-ui/react';
import PlayerCard from './components/PlayerCard';
import Team from './components/Team'
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './utils/PrivateRoute';
import AddPlayer from './components/AddPlayer';
import AddTeam from './components/AddTeam';
import Sidebar from './components/SideBar';
import AllPlayers from './components/AllPlayers';
import Teams from './components/Teams';
import SoldPlayer from './components/SoldPlayer';
import PrintComponent from './components/PrintComponent';
import ReservedPlayers from './components/ReservedPlayers';
import PrintTeam from './components/PrintTeam';
import AddCat from './components/addCat';

function App() {

  localStorage.setItem('chakra-ui-color-mode', 'dark')

  return (

    <ChakraProvider>
        <AppProvider>
          <AuthProvider>
            <BrowserRouter>
              
                {/* <Header/> */}
                <Sidebar>
                <Routes>
                  <Route exact path="/" element={<Home/>} />
                  {/* <R" element={<Home/>} /> */}
                  <Route exact path="/players" element={
                    <Players/>
      
                  } />

                  <Route exact path="/printteam" element={<PrintTeam/>}/>

                  <Route exact path="/playerProf" element={
                  
                    <PlayerCard/>
                 
                  }/>
                  <Route exact path="/team" element={
                    <Team/>
                  } />
                  <Route exact path="/teams" element={
                    <Teams limited={false} compart={false}/>
                  } />
                  <Route exact path="/addplayer" element={
                  <PrivateRoute>
                    <AddPlayer/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/addteam" element={
                  <PrivateRoute>
                    <AddTeam/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/allplayers" element={
                  <PrivateRoute>
                    <AllPlayers/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/addCat" element={
                  <PrivateRoute>
                    <AddCat/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/soldplayers" element={
                  <PrivateRoute>
                    <SoldPlayer/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/reservedplayers" element={
                  <PrivateRoute>
                    <ReservedPlayers/>
                  </PrivateRoute>
                  } />
                  <Route exact path="/printplayers" element={
                    <PrintComponent/>
                  } />
                </Routes>
                </Sidebar>
                
            </BrowserRouter>
          </AuthProvider>
        </AppProvider>
      </ChakraProvider>

  );
}

export default App;
